import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
// import axios from "axios";
import Popup from "reactjs-popup";
import gmail from "src/Assets/images/gmail.svg";
import facebook from "src/Assets/images/fb.svg";
import Api from "src/network";
import "src/Assets/css/Moderator/InviteMembers.css";
import { emailRegex } from "src/Constants/regex";
import MessageModal from "src/Utils/messageModal";
import { CircularProgress } from "@material-ui/core";
import Chip from "src/pages/HomePage/components/Invitations/Chip";

const ModalType = {
  Message: "MESSAGE",
};

function Invitemembers(props) {
  const baseUrl = process.env.REACT_APP_SERVICES_API;
  const { tenantId, tenantName } = props || {};
  // const moderatingCommunitysData = useSelector(
  //   (state) => state.ModeratorReducer.moderatingCommunitysData
  // );
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const [mail, setMail] = useState("");
  const [subject, setSubject] = useState("");
  const [textmsg, setTextmsg] = useState("");
  const [uiSubject, setUiSubject] = useState("");
  const [UiTextmsg, setUiTextmsg] = useState("");
  const [msg, setMsg] = useState("");
  // const [closeInvites, setCloseInvites] = useState(null);
  // const [messageShow, setMessageShow] = useState(false);
  const [allEmails, setAllEmails] = useState([]);
  const [isInviting, setIsInviting] = useState(false);
  const [modalType, setModalType] = useState(null);

  const emailChange = (e) => {
    setMail(e.target.value);
  };

  const onBlurEmailField = () => {
    validateEmail();
  };

  const handleKeyDown = (evt) => {
    if ([" ", ";", ","].includes(evt.key)) {
      evt.preventDefault();
      validateEmail();
    }
  };

  const validateEmail = () => {
    const newEmail = mail.trim();
    if (!newEmail) return;
    const isValid = emailRegex.test(newEmail);
    const id = `ID${new Date().getTime()}`;
    setAllEmails((prevState) => [
      ...prevState,
      { id, email: newEmail, isValid },
    ]);
    setMail("");
  };

  useEffect(() => {
    const { displayName } = userDetails?.userData || {};
    setSubject(`Invitation to join %7BtenantName%7D via Skopic`);
    setTextmsg(
      `Hi,%0A%0AI request you to join %7BtenantName%7D on Skopic.%0A%0AStay connected with your community, engage in meaningful discussions, and collaborate with other members on relevant topics.%0A%0ATogether, we can build a stronger and more informed community.%0A%0AThank you,%0A%7BdisplayName%7D`,
    );
    setUiSubject(`Invitation to join ${tenantName} via Skopic`);

    setUiTextmsg(` Hi,

 I request you to join  ${tenantName}  on Skopic.
 
Stay connected with your community, engage in meaningful discussions, and collaborate with other members on relevant topics.
 
Together, we can build a stronger and more informed community.

 Thank you
 ${displayName}`);
  }, [userDetails, tenantId, tenantName]);

  const onInviteHandler = (e) => {
    e?.preventDefault();
    if (isInviting) return;

    setIsInviting(true);

    let validEmails = allEmails
      .filter((ele) => ele?.isValid)
      .map((ele) => ele?.email);
    if (mail && mail.trim()) {
      validEmails = [...validEmails, mail];
    }
    const emailsParam = validEmails.join(",");

    Api.inviteFriendThroughModerator(emailsParam, textmsg, subject, tenantId)
      .then((res) => {
        setMsg(res.data.status);
        setMail("");
        setAllEmails([]);
        setModalType(ModalType.Message);
        setIsInviting(false);
      })
      .catch((e) => {
        console.error(e);
        setIsInviting(false);
      });
  };

  const isSumbitHandler = () => {
    const newEmail = mail?.trim();
    const hasValidEmail = allEmails?.some((ele) => ele?.isValid);
    if ((newEmail && emailRegex.test(newEmail)) || hasValidEmail) {
      return true;
    } else {
      return false;
    }
  };

  // const closeInviteHandler = () => {
  //     setCloseInvites(props.onHide)
  //     setMessageShow(true)
  // }

  const generateGoogleAuthUrl = () => {
    const landingPageUrl = process.env.REACT_APP_LANDING_PAGE;
    const clientId =
      "1096351929813-b3sqsgi9t95dfbr7jhsruvsfvh8q6iac.apps.googleusercontent.com";
    const redirectUri = `${landingPageUrl}home`;
    const scope = "https://www.googleapis.com/auth/contacts.readonly";
    const accessType = "offline";
    const includeGrantedScopes = true;
    const responseType = "code";
    const state = JSON.stringify({
      tenantId,
      tenantName,
    });

    const authUrl =
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `scope=${encodeURIComponent(scope)}&` +
      `access_type=${encodeURIComponent(accessType)}&` +
      `include_granted_scopes=${includeGrantedScopes}&` +
      `response_type=${encodeURIComponent(responseType)}&` +
      `state=${encodeURIComponent(state)}&` +
      `redirect_uri=${encodeURIComponent(redirectUri)}&` +
      `client_id=${encodeURIComponent(clientId)}`;

    return authUrl;
  };

  const closeModal = () => {
    setModalType(null);
    setMsg("");
  };

  const handleChipDelete = (id) => {
    const copiedEmails = [...allEmails];
    setAllEmails(copiedEmails.filter((ele) => ele?.id !== id) || []);
  };

  // Example usage:
  const googleAuthUrl = generateGoogleAuthUrl();
  // console.log(googleAuthUrl);
  const isEnabaled = isSumbitHandler();

  return (
    <>
      <div className="background-for-whole">
        <div>
          <div className="Invitaion InviteStyles">
            <div className="InvitationEmail">
              <label>Email:</label>
              <div className="emailChip">
                {allEmails?.map((each) => (
                  <Chip
                    key={each?.id}
                    label={each?.email}
                    onDelete={() => handleChipDelete(each?.id)}
                    isValid={each?.isValid}
                  />
                ))}
                <input
                  type="text"
                  value={mail}
                  onChange={emailChange}
                  onKeyDown={handleKeyDown}
                  // onBlur={onBlurEmailField}
                  className="inputEmail"
                />
              </div>
              {/* <input
                type="text"
                value={mail}
                onChange={emailChange}
                onKeyDown={handleKeyDown}
                maxLength="50"
              />
              {isEmailInvalid && <p style={{ color: "red", fontSize: 11, padding: 0, margin: 0 }}>Please enter a valid Email</p>}
              {email.map((mail) => (
                <div key={mail} className="multipleEmail">
                  {" "}
                  {mail}{" "}
                  <button
                    type="button"
                    className="button"
                    onClick={() => handleDelete(mail)}
                  >
                    &times;
                  </button>
                </div>
              ))} */}
            </div>
            <div className="InvitationSubject">
              Subject:
              <input
                type="text"
                value={uiSubject}
                readOnly
                style={{ color: "#949494" }}
              />
            </div>
            <div className="InvitationTextaera">
              <label>Message:</label>
              <div>
                <textarea
                  style={{ scrollbarWidth: "none", color: "#949494" }}
                  rows="11"
                  cols="50"
                  defaultValue={UiTextmsg}
                  readOnly
                />
              </div>
            </div>
            <button
              type="button"
              onClick={onInviteHandler}
              className="Invite"
              style={{
                margin: "0 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              disabled={!isEnabaled}
            >
              {isInviting ? (
                <CircularProgress size={20} color="white" />
              ) : (
                "Invite"
              )}
            </button>

            <div className="or-container">
              <hr />
              <p>or</p>
              <hr />
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <div className="InviteOptionsContainer_align">
                <button
                  className="GmailContacts_align"
                  onClick={() => (window.location.href = googleAuthUrl)}
                >
                  <img src={gmail} alt="gmailIcon" />
                  <span> Invite Gmail contacts</span>
                </button>
              </div>
            </div>
            {/* <button type="submit" className="Invite"  disabled={!isEnabaled}>Invite</button> */}
            {/* <button type="submit" onClick={''} className="Invite" disabled={!isEnabaled}>Invite via Gmail</button> */}
          </div>
        </div>

        {modalType === ModalType.Message && (
          <MessageModal
            show={modalType === ModalType.Message}
            onHide={closeModal}
            message={msg}
          />
        )}
      </div>
    </>
  );
}

export default Invitemembers;
